/**
 * The external Rub maps site, linked from the menu and the footer while the `venues.enabled`
 * setting is off. A compiled constant rather than a setting: settings hold numbers and switches,
 * and the domain is a placeholder until the site exists. This is the one place the deep link's
 * shape is decided.
 */
export const RUB_MAPS_ORIGIN = 'https://rubntugmap.com';

/** The map for one place when the reader is on that place's page, else the site's front. */
export function rubMapsUrl(placeId?: string | null): string {
  return placeId ? `${RUB_MAPS_ORIGIN}/c/${encodeURIComponent(placeId)}` : `${RUB_MAPS_ORIGIN}/`;
}
